import {DesignChecker, DesignFlaw} from "../designChecker";
import {MyDiagramModel} from "../../MyDiagramModel";

export abstract class Checker implements DesignChecker {
    abstract run(model: MyDiagramModel): DesignFlaw[]
}
